if (!customElements.get('product-card-hover-media')) {
  class ProductCardHoverMedia extends HTMLElement {
    constructor() {
      super();
      this._hydrated = false;
      this._handleMediaChange = this._handleMediaChange.bind(this);
    }

    connectedCallback() {
      if (this._mediaQuery) return;
      this._template = this.querySelector('template');
      if (!this._template) return;

      this._mediaQuery = window.matchMedia('(min-width: 1024px)');
      this._mediaQuery.addEventListener('change', this._handleMediaChange);
      this._handleMediaChange(this._mediaQuery);
    }

    disconnectedCallback() {
      this._mediaQuery?.removeEventListener('change', this._handleMediaChange);
      this._mediaQuery = null;
      this._teardown();
    }

    _handleMediaChange(event) {
      if (event.matches) {
        this._hydrate();
      } else {
        this._teardown();
      }
    }

    _hydrate() {
      if (this._hydrated) return;
      this.appendChild(this._template.content.cloneNode(true));
      this._hydrated = true;
    }

    _teardown() {
      if (!this._hydrated) return;
      [...this.children].forEach((child) => {
        if (child !== this._template) child.remove();
      });
      this._hydrated = false;
    }
  }

  customElements.define('product-card-hover-media', ProductCardHoverMedia);
}
